"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.records.title': '您的入职记录',
    'onboarding.records.empty.title': '尚无入职记录',
    'onboarding.records.empty.description': '开始您的第一个入职流程以在此查看记录。',
};
